import React, { useState, useEffect } from 'react';
import { Button, Tag, message, Empty, Spin, Timeline } from 'antd';
import { listSensorsEvents } from '@/services/userManager';
import { guuid } from '@/utils/utils';

const PathRecordView = (props) => {
  // eslint-disable-next-line react/prop-types
  const { userId } = props;
  const [pathRecord, setPathRecord] = useState([]);
  const [pathCurrentPage, setPathCurrentPage] = useState(1);
  const [pathIsEnd, setPathIsEnd] = useState(false);
  const [pathIsLoading, setPathIsLoading] = useState(false);
  useEffect(() => {
    // 请求第一页行为路径
    getPath();
  }, []);
  // 获取行为路径
  const getPath = async () => {
    setPathIsLoading(true);
    listSensorsEvents({
      requestData: { userId: userId },
      page: {
        currentPage: pathCurrentPage,
        pageSize: 10,
      },
    }).then(({ page, code, data, msg }) => {
      setPathIsLoading(false);
      if (code === '00000') {
        const newRecord = [...pathRecord, ...data];
        setPathRecord(newRecord || []);
        if (newRecord.length === page.count) {
          setPathIsEnd(true);
        }
        // page++
        setPathCurrentPage(pathCurrentPage + 1);
      } else {
        message.error(msg);
      }
    });
  };

  return (
    <div>
      {pathRecord.length === 0 ? (
        <div>
          <Empty>
            {' '}
            <Spin hidden={!pathIsLoading} />{' '}
          </Empty>
        </div>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <Timeline pending={pathIsLoading ? '加载中..' : ''} mode={'left'}>
            {pathRecord?.map((e) => {
              return (
                <Timeline.Item key={guuid()} label={e?.time}>
                  <div style={{ background: '#f5f5f5' }}>
                    {Object.keys(e).map((key, index) => (
                      <Tag
                        color={key === 'event' ? '#f50' : 'default'}
                        key={key}
                      >
                        {key} : {e[key]}{' '}
                      </Tag>
                    ))}
                  </div>
                </Timeline.Item>
              );
            })}
          </Timeline>
          <Button
            hidden={pathIsEnd}
            onClick={getPath}
            type="primary"
            style={{ marginTop: 16 }}
          >
            更多
          </Button>
        </div>
      )}
    </div>
  );
};

export default PathRecordView;
